export const isFunction = (item: unknown): item is Function => {
  return typeof item === 'function';
}